import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom';
import { PatientStatusCode, getMedicationsTypeIntake, getMedicineNameStage, getTestingstageTaskOnTask, getTools } from '../../api/chatApi/chatApi'
import chatService from '../../api/chatService'
import RatingDialog from '../../components/Chat/RatingDialog'
import ButtonWithProgress from '../../components/common/ButtonWithProgress'
import MainLayout from '../../components/Layout/MainLayout'
import InspectionTooltip from '../../components/Tooltips/InspectionTooltip'
import { objectiveStatusTypesIds } from '../../constants/default'
import useIncreaseTaskStage from '../../hooks/testingTask/useIncreaseTaskStage'
import useTestingStage from '../../hooks/testingTask/useTestingStage'
import useChatHistory from '../../hooks/useChatHistory'
import useCheckHistory from '../../hooks/useCheckHistory'
import useResearchHistoryByTitle from '../../hooks/useResearchHistoryByTitle'
import useTooltipState from '../../hooks/useTooltipState'
import { newCheckAnswerToHistory } from '../../store/actionCreator'
import { RoutePath } from '../../types'
import NewChatWizardTopMenu from '../startChatWizard/NewChatWizardTopMenu'
import chatApi from '../../api/chatApi'
import TooltipAccordion from '../../components/TooltipAccordion'
import { createStyles, makeStyles, Tooltip } from '@material-ui/core';
import { usePointProcentStore } from './store'
import useNextStageInfo from '../../hooks/testingTask/useNextStageInfo';
import ObjectiveStateManipulation from '../../components/ChatBlocks/Manipulation/ObjectiveStateManipulation';
import TooltipDialog from '../../components/common/TooltipDialog';
import ChatTooltip from '../../components/Tooltips/ChatTooltip';

interface TooltipData {
  testingstage_id: number;
  name: string;
  job_hint: string;
  stage_hint: string;
  stage_hint_name: string;
  stage_hint_blue: string;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    radioBtn: {
      alignItems: 'flex-start',
      '& span': {
        paddingTop: 0
      }
    },
    slot: {
      borderRadius: '10px 10px 0 0'
    },
    slotContainer: {
      border: '2px solid rgba(0, 0, 0, 0.12)',
      background: '#fff',
      borderRadius: '20px',
      padding: '6px',
      height: '200px',
      width: '100%'
    },
    formControl: {
      border: 'none !important'
    },
    patientConditionSlotClass: {
      marginBottom: '40px',
      minWidth: 450,
      '@media (max-width: 800px)': {
        minWidth: '90%'
      },
    },
    manipulationsColumn: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      width: '100%',
      maxWidth: '100%',
      margin: '20px auto 50px',
      overflowX: 'auto',
      overflowY: 'hidden',
      '&::-webkit-scrollbar': {
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: theme.palette.background.default,
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.grey[400],
        borderRadius: '4px',
        '&:hover': {
          background: theme.palette.grey[500],
        },
      },
    },
    manipulationTitle: {
      textAlign: 'center',
      fontWeight: 'bold',
      marginBottom: theme.spacing(2),
    },
    manipulationItem: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: '120px',
      alignItems: 'center',
      padding: theme.spacing(1),
      borderRadius: theme.spacing(1),
      transition: 'transform 0.2s ease-in-out',
      '&:hover': {
        opacity: 0.8,
        transform: 'scale(1.05)',
      },
    },
    manipulationImage: {
      width: '70px',
      height: '70px',
      marginBottom: theme.spacing(1),
      borderRadius: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '60px',
        height: '60px',
      },
    },
    manipulationName: {
      textAlign: 'center',
      fontSize: '0.875rem',
      lineHeight: '1.4',
      wordWrap: 'break-word',
      padding: theme.spacing(0.5),
      minHeight: '2.8em',
      maxHeight: '2.8em',
      overflow: 'hidden',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      whiteSpace: 'pre-wrap',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.75rem',
      },
    },
    tooltip: {
      backgroundColor: '#1876d1',
      color: 'white',
      boxShadow: theme.shadows[2],
      fontSize: '0.95rem',
      padding: '4px 8px',
      maxWidth: 200,
      textAlign: 'center',
      '& .MuiTooltip-arrow': {
        color: '#1876d1',
      },
    },
  })
);

interface Stage {
  routePath: string;
  activeStage: number;
  code?: string;
  legend_id?: number;
}

export default function ManipulationPage() {
  const classes = useStyles()
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [stages, setStages] = useState<Stage[]>([]);
  const { routhPathCode, activeStage } = useNextStagePath(stages);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false)
  const testingStage = useTestingStage()
  const location = useLocation();
  const history = useHistory();
  const [manualActiveStage, setManualActiveStage] = useState(false)
  const nextStage = useNextStageInfo()
  const [taskId, setTaskId] = useState<number>(0)
  const [currentStage, setCurrentStage] = useState<any>(null)
  // Функция для получения этапов
  async function fetchAllStages() {
    try {
      const result = await getTestingstageTaskOnTask();
      setStages(result.data.testingstage_task_on_task);
      const currentStage = result.data.testingstage_task_on_task.find((stage: Stage) => stage.routePath === '/manipulation');
      setCurrentStage(currentStage);
    } catch (error) {
      console.error('Ошибка при загрузке этапов:', error);
    }
  }

  useEffect(() => {
    fetchAllStages();
  }, []);

  const [medicineNameStage, setMedicineNameStage] = useState<string>('')

  async function getNameStage() {
    if (!taskId || !currentStage) {
      return
    }
    
    try {
      const result = await getMedicineNameStage({ task_id: taskId })
      
      if (result?.data?.MedicineNameStage) {
        const matchingStage = result.data.MedicineNameStage.find((item: any) => 
          item.testingstage_id === currentStage.testingstage_id
        )
        const stageName = matchingStage?.name
        setMedicineNameStage(stageName || '')
      } else {
        setMedicineNameStage('')
      }
    } catch (error) {
      console.error('Error fetching stage name:', error)
      setMedicineNameStage('')
    }
  }

  useEffect(() => {
    getNameStage()
  }, [taskId, currentStage])

  function useNextStagePath(stages) {
    const location = useLocation();
    const currentPath = location.pathname;

    if (!stages || stages.length === 0) {
      return { routePath: '', routhPathCode: '' };
    }
    const sortedStages = stages.sort((a, b) => a.activeStage - b.activeStage);
    const currentIndex = sortedStages.findIndex(stage => stage.routePath === currentPath);
    if (currentIndex !== -1 && currentIndex + 1 < sortedStages.length) {
      return {
        routePath: sortedStages[currentIndex + 1].routePath,
        routhPathCode: sortedStages[currentIndex + 1].routhPathCode,
        activeStage: sortedStages[currentIndex + 1].activeStage
      };
    }

    return { routePath: '', routhPathCode: '' };

  }

  // для загрузки очков в сайдбаре
  useResearchHistoryByTitle();
  useChatHistory();
  const getPointProcent = usePointProcentStore(state => state.getPoints)

  const checkHistory = useCheckHistory();


  const onParamClick = (paramName: string) => {
    // игнорируем клик если данные по этому параметру уже есть
    if (checkHistory?.value && checkHistory.value[paramName] !== null) return;

    const anamnesisId = objectiveStatusTypesIds[paramName];
    chatService.checkObjectiveState(anamnesisId).then((data) => {
      dispatch(newCheckAnswerToHistory({ ...data, paramName: paramName }));
    });
  };


  const [loading, increase, setAsyncTaskStage] = useIncreaseTaskStage(nextStage?.routePath, nextStage?.activateStage);
  const [tooltipState, openTooltip] = useTooltipState();
  const [medicineId, setMedicineId] = useState<number>(0);

  // Функция для перехода на следующий этап, если текущий этап уже пройден
  async function goToNextStage() {
    const currentPath = location.pathname;
    const currentStageObj = stages.find(stage => stage.routePath === currentPath);

    if (!currentStageObj) {
      setHistoryStage(4);
      return;
    }

    const currentActiveStage = currentStageObj.activeStage;
    if (!currentActiveStage) return;

    setHistoryStage(currentActiveStage);

    const sortedNextStages = stages
      .filter(stage => stage.activeStage > currentActiveStage)
      .sort((a, b) => a.activeStage - b.activeStage);

    if (sortedNextStages.length === 0) {
      console.warn('Нет доступных следующих стадий.');
      return;
    }

    let nextIndex = 0;

    if (sortedNextStages[nextIndex].code === 'conclusion') {
      nextIndex += 1;

      if (nextIndex >= sortedNextStages.length) {
        nextIndex = 0;
      }
    }

    const finalNextStage = sortedNextStages[nextIndex];

    if (finalNextStage.legend_id) {
      history.push({
        pathname: RoutePath.legend,
        state: {
          legendId: finalNextStage.legend_id
        }
      });
    } else {
      history.push(finalNextStage.routePath);
    }
  }

  async function getHistoryStage() {
    setIsLoadingBtn(true)
    try {
      const res = await chatApi.getTestingStageHistory()
      const result = res.result.find((el) => el.activeStageId === 4)
      if (result && (!stages || stages.length === 0)) {
        setManualActiveStage(true)
      }
      setIsLoadingBtn(false)

    } catch (error) {
      console.log(error)
      setIsLoadingBtn(false)
    }
  }

  async function setHistoryStage(testingStage) {
    try {
      await chatApi.setTestingStageHistory(testingStage)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getHistoryStage()
  }, [])



  const [status, setStatus] = useState<boolean>(false)
  const taskName = '24'

  useEffect(() => {
    getMedicineNameStages()
  }, [])


  useEffect(() => {
    const getDialogStatus = async () => {
      try {
        const response = await chatApi.getSettingsPiloting();
        const statusValue = response?.result?.[0]?.value;
        setStatus(statusValue === 'true');
      } catch (error) {
        console.log('Не удалось получить настройки пилотинга', error)
        setStatus(false)
      }
    };

    void getDialogStatus();
  }, []);


  const [returnedStage, setReturnedStage] = useState<boolean>(false);

  function checkNextStage() {
    if (stages.length > 0) {
      const res = stages.find(el => el.routePath === location.pathname)
      let passedStage = 0
      if (res) {
        passedStage = stages.indexOf(res) + 1
      }
      if (testingStage > passedStage) {
        setReturnedStage(true)
      }
    }
  }

  useEffect(() => {
    checkNextStage()
  }, [activeStage])


  function showRatingDialog() {
    if (stages) {
      goToNextStage()
    } else {
      setHistoryStage(4)
      increase()
    }
  }


  function hideRatingDialog() {
    increase();
    // setAsyncTaskStage()
    setOpen(false);
  }


  useEffect(() => {
    getPointProcent()
    unfinishedTaskHandler()
  }, [])

  async function unfinishedTaskHandler() {
    try {
      const response = await chatApi.unfinishedTask()
      setMedicineId(response.result.task.medicineId)
    } catch (err) {
      console.log('при выполнении unfinishedTaskHandler', err);
    }
  }

  const [toolsRightBar, setToolsRightBar] = useState<any>([]);
  const [medicationsLeftBar, setMedicationsLeftBar] = useState<any>([]);
  const [selectedInstruments, setSelectedInstruments] = useState<{ [key: number]: boolean }>({});
  const [isCorrectInstrument, setIsCorrectInstrument] = useState<{ [key: number]: boolean }>({});

  const handleInstrumentSelect = (instrumentId: number, isCorrect: boolean) => {
    setSelectedInstruments(prev => ({
      ...prev,
      [instrumentId]: true
    }));
    setIsCorrectInstrument(prev => ({
      ...prev,
      [instrumentId]: isCorrect
    }));
  };


  const getToolsRightBar = async () => {
    try {
      const result = await getTools();
      setToolsRightBar(result.data.tools);
    } catch (err) {
      console.log(`при получении инструментов произошла ошибка: ${err}`)
    }
  }

  const getMedicationsLeftBar = async () => {
    try {
      const result = await getMedicationsTypeIntake();
      setMedicationsLeftBar(result.data.medications_type_intake);
    } catch (err) {
      console.log(`при получении лекарств произошла ошибка: ${err}`)
    }
  };


  useEffect(() => {
    getToolsRightBar();
    getMedicationsLeftBar();
  }, []);


  const [tooltipText, setTooltipText] = useState<TooltipData | null>(null)


  async function getMedicineNameStages() {
    try {
      const result = await getMedicineNameStage({ task_id: taskId })

      if (result.data.MedicineNameStage && result.data.MedicineNameStage.length > 0 && currentStage) {
        const stageHintElement = result.data.MedicineNameStage.find(el => el.testingstage_id === currentStage.testingstage_id)
        setTooltipText(stageHintElement)
      }

    } catch (error) {
      console.log(error)
    }
  }


  return (
    <MainLayout
      desktopHeader={<NewChatWizardTopMenu title={'Манипуляции'} />}
      title={medicineNameStage || 'Манипуляции'}
      onClickTooltip={openTooltip}
    >
      {open ? <RatingDialog open={open} onSubmit={hideRatingDialog} /> : null}
      <TooltipDialog {...tooltipState}>
        {currentStage && <ChatTooltip task_id={taskId} testingStageId={currentStage.testingstage_id} />}
      </TooltipDialog>
      {/* <TooltipAccordion taskName={taskName} /> */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginBottom: 30
      }}>
        <div
          style={{
            width: '100%',
            padding: `8px`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '20px'
          }}
        >
          {checkHistory?.value ? (
            <ObjectiveStateManipulation
              paramData={{ ...checkHistory?.value }}
              onParamClick={onParamClick}
              onHumanClick={alert}
              onInstrumentSelect={handleInstrumentSelect}
            />
          ) : null}
        </div>

        <div style={{ width: '100%', maxWidth: '60%' }}>
          {/* <div className={classes.manipulationsColumn}>
            {toolsRightBar.map((manipulation) => (
              <Tooltip 
                key={manipulation.id}
                title={manipulation.tools}
                placement="top"
                enterDelay={300}
                arrow
                classes={{
                  tooltip: classes.tooltip
                }}
              >
                <div className={classes.manipulationItem}>
                  <img
                    src={CircleEnabled}
                    alt={manipulation.name}
                    className={classes.manipulationImage}
                    style={{
                      backgroundColor: selectedInstruments[manipulation.id] 
                        ? (isCorrectInstrument[manipulation.id] ? 'green' : '#ff665e')
                        : '#9E9E9E'
                    }}
                  />
                  <div className={classes.manipulationName}>{manipulation.tools}</div>
                </div>
              </Tooltip>
            ))}
          </div> */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px'
            }}
          >
            <ButtonWithProgress
              variant='contained'
              color='primary'
              loading={loading}
              onClick={() => showRatingDialog()}
            >
              {isLoadingBtn ? ' ' : manualActiveStage ? 'Следующий этап' : 'Закончить этап'}
            </ButtonWithProgress>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}
